import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { format } from 'date-fns';
import { allOperators, standardOperators } from '../../../Compounds/UpstackDataGrid/helpers';
import { DetailCTARenderer } from '../../../Compounds/UpstackDataGrid/CellRenderers/DetailCTARenderer';

export const DefaultAccountGridColumnDefs: GridSingleSelectColDef[] = [
  {
    field: 'details',
    headerName: '',
    sortable: false,
    width: 65,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
      />
    ),
    hideable: false,
    disableReorder: true
  },
  {
    field: 'name',
    headerName: 'Account Name',
    sortable: true,
    filterable: true,
    type: 'singleSelect',
    width: 300,
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'customizations',
    headerName: 'Customizations',
    sortable: false,
    filterable: false,
    valueGetter: (value, row) => row?.accountCustomizations.content?.customizations,
    type: 'singleSelect',
    valueOptions: [],
    width: 200,
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'sub_accounts',
    headerName: 'Sub Accounts',
    sortable: false,
    width: 200,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'users',
    headerName: 'Number of Users',
    sortable: false,
    width: 200,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'last_updated',
    headerName: 'Last Updated',
    sortable: false,
    flex: 1,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    valueFormatter: (value) => {
      return value ? format(value, 'PPpp') : '';
    },
    filterOperators: allOperators(),
    description: 'Drag to move column'
  }
];
